import { Component } from "react";

class Chatbot extends Component {
    render() {
        return (
            <div>
                <h1>Inside chatbot2</h1>
            </div>
        );
    }
}

export default Chatbot;